module.exports = __webpack_public_path__ + "./docs/img/icon-tutorial.701beb8ab5491c0636d01093ba10ccca.svg";